import { lockScroll, unlockScroll } from '@theme/utilities';

const COOKIE_NAME = 'shizuku_age_ok';

/**
 * A custom element that gates the storefront behind an 18+ confirmation.
 *
 * Shows a non-dismissable modal on first visit (per browser session).
 * Confirming sets a session cookie and unlocks the page; declining is a
 * plain link to the exit URL, so it also works without this script.
 */
class AgeGateComponent extends HTMLElement {
  #accepted = false;

  connectedCallback() {
    if (this.#hasCookie() || window.Shopify?.designMode) return;

    const dialog = this.querySelector('dialog');
    if (!(dialog instanceof HTMLDialogElement)) return;

    dialog.addEventListener('cancel', (event) => event.preventDefault());
    dialog.addEventListener('close', () => {
      // Escape can force-close a modal despite a cancelled `cancel` event
      // (close watcher); reopen unless the visitor confirmed.
      if (!this.#accepted) dialog.showModal();
    });

    this.querySelector('[data-age-gate-confirm]')?.addEventListener('click', () => {
      this.#accepted = true;
      document.cookie = `${COOKIE_NAME}=1; path=/; SameSite=Lax`;
      unlockScroll(dialog);
      dialog.close();
    });

    this.querySelector('[data-age-gate-decline]')?.addEventListener('click', (event) => {
      if (!(event.currentTarget instanceof HTMLElement)) return;
      event.currentTarget.closest('.age-gate__actions')?.setAttribute('hidden', '');
      this.querySelector('[data-age-gate-denied]')?.removeAttribute('hidden');
    });

    requestAnimationFrame(() => {
      lockScroll(dialog);
      dialog.showModal();
    });
  }

  #hasCookie() {
    return document.cookie.split('; ').includes(`${COOKIE_NAME}=1`);
  }
}

if (!customElements.get('age-gate-component')) customElements.define('age-gate-component', AgeGateComponent);
